var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card shadow mb-4" }, [
    _c("div", { staticClass: "card-header py-3" }, [
      _c("h6", { staticClass: "m-0 font-weight-bold text-primary" }, [
        _c("i", { staticClass: "fas fa-fw fa-cog" }),
        _vm._v(" " + _vm._s(_vm.title))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", {}, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tab-content", attrs: { id: "nav-tabContent" } },
          [
            _c(
              "div",
              {
                staticClass:
                  "tab-pane fade show active p-3 border-left border-bottom border-right",
                attrs: {
                  id: "nav-ads",
                  role: "tabpanel",
                  "aria-labelledby": "nav-ads-tab"
                }
              },
              [_c("system-analytics-ads")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "tab-pane fade show active p-3 border-left border-bottom border-right",
                attrs: {
                  id: "nav-fbrequests",
                  role: "tabpanel",
                  "aria-labelledby": "nav-fbrequests-tab"
                }
              },
              [_c("system-analytics-fb-requests")],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("nav", [
      _c(
        "div",
        {
          staticClass: "nav nav-tabs",
          attrs: { id: "nav-tab", role: "tablist" }
        },
        [
          _c(
            "a",
            {
              staticClass: "nav-item nav-link active",
              attrs: {
                id: "nav-ads-tab",
                "data-toggle": "tab",
                href: "#nav-ads",
                role: "tab",
                "aria-controls": "nav-ads",
                "aria-selected": "true"
              }
            },
            [_vm._v("Ads")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "nav-item nav-link",
              attrs: {
                id: "nav-fbrequests-tab",
                "data-toggle": "tab",
                href: "#nav-fbrequests",
                role: "tab",
                "aria-controls": "nav-fbrequests",
                "aria-selected": "true"
              }
            },
            [_vm._v("FB")]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }